import * as App from '../../app';
import * as Backend from '../../backend-api';
export function updateBalance(cb) {
    Backend.getBalance()
        .then(function (res) {
        App.Fn.updateCoins(res.balance);
        cb && cb(true);
        return res;
    })
        .catch(function (err) {
        cb && cb(false);
        App.stat.error(err);
        return err;
    })
        .then(function (res) {
        DEBUG && console.log('updateBalance', res);
    });
}
